<template>
  <LoadingSpinner v-if="isLoading" />
  <div v-show="!isReordering && !isLoading" style="height: 100%">
    <SideBarGroup
      v-for="item in items"
      :key="item.id"
      :overviewContent="getOverviewContent(item)"
      :current="editingItem.key"
      :hasFormUnfilled="hasFormUnfilled"
      @expand="handleExpand(item)"
      @save="handleSave(item.id)"
      @delete="handleDelete(item.id)"
    >
      <template #items>
        <SideBarImage
          v-model:image="collaborationImage"
          itemName="合作夥伴標誌"
        />
        <SideBarText
          v-model="collaboration"
          itemName="名稱"
          :text="collaboration"
          placeholder="我的合作夥伴⋯⋯"
          :autoFocus="true"
        />
      </template>
    </SideBarGroup>
    <div v-if="items.length == 0" class="sideBarEmptyState">
      <!-- <div class="illustration">
      <img :src="props.emptyStates.illustration" width="100" height="100" />
    </div> -->
      <div class="messages">
        <h1>空無一物</h1>
        <h1 class="sub">請點選「新增」來開始撰寫。</h1>
      </div>
    </div>
  </div>
  <SideBarReordering
    v-show="isReordering"
    :items="items"
    label="name"
    sort="id"
  />
</template>

<script setup>
import { defineProps, watch, ref, inject, onBeforeMount, computed } from "vue"
import { useLoading } from "@/composables/useLoading"
import { storeToRefs } from "pinia"
import { useStashStore } from "@/store/stash"
import { useMessageStore } from "@/store/message"
import SideBarGroup from "../../SideBarGroup.vue"
import SideBarImage from "../../SideBarImage.vue"
import SideBarText from "../../SideBarText.vue"
import LoadingSpinner from "@/components/LoadingSpinner.vue"
import SideBarReordering from "../../SideBarReordering.vue"

const props = defineProps({
  count: {
    type: Number,
    default: 0,
  },
  isReordering: {
    type: Boolean,
    default: false,
  },
})

const items = ref([])

const stashStore = useStashStore()
const messageStore = useMessageStore()
const { data } = storeToRefs(stashStore)
const { actions } = storeToRefs(messageStore)

watch(
  () => props.count,
  (val) => {
    if (val > 0) {
      const newItem = {
        id: items.value.length + 1,
        name: "",
        image: "",
      }
      items.value.push(newItem)
      handleExpand(newItem)
    }
  }
)

const editingItem = ref({
  key: -1,
  text: "",
  image: "",
})
const handleExpand = (item) => {
  editingItem.value = { key: item.id, text: item.name, image: item.image }
  hasFormUnfilled.value = false
}
const getOverviewContent = (item) => {
  return {
    key: item.id,
    title: "合作夥伴",
    description: item.name,
  }
}

const collaboration = ref("")
const collaborationImage = ref("")
const hasFormUnfilled = ref(false)

// 儲存
const handleSave = (index) => {
  return hasChanged.value ? checkCourse(index) : handleExpand("", -1)
}
const checkCourse = (index) => {
  hasFormUnfilled.value = [
    collaboration.value,
    collaborationImage.value,
  ].includes("")

  if (!hasFormUnfilled.value) {
    setCollaborationData("edit", index)
    editCollaboration()
  }
}
const hasChanged = computed(
  () =>
    collaboration.value !== editingItem.value.text ||
    collaborationImage.value !== editingItem.value.image
)

// 更新順序
watch(
  () => props.isReordering,
  () => {
    if (!props.isReordering) {
      emitAction.value = "edit"
      editCollaboration()
    }
  }
)

// 刪除
const stashItems = ref([])
const handleDelete = (index) => {
  if (items.value[index - 1].name === "") {
    items.value.splice(index - 1, 1)
  } else {
    setCollaborationData("delete", index)
    stashStore.stash(stashItems.value)
    editCollaboration()
  }
}

const emitAction = ref("")
const setCollaborationData = (action, index) => {
  switch (action) {
    case "edit":
      items.value[index - 1].name = collaboration.value
      items.value[index - 1].image = collaborationImage.value
      emitAction.value = "edit"
      break
    case "delete":
      stashItems.value = JSON.parse(JSON.stringify(items.value)).filter(
        (item) => item.name !== ""
      )
      items.value.splice(index - 1, 1)
      emitAction.value = "delete"
      break
  }

  items.value = items.value.filter((item) => item.name !== "")
}
watch(
  () => actions.value,
  (val) => {
    if (val === "復原") {
      items.value = data.value
      emitAction.value = ""
      editCollaboration()
      messageStore.action("")
      stashStore.stash([])
    }
  }
)

// 取得合作夥伴
const $http = inject("http")
const { load, unload, isLoading } = useLoading()
const getCollaboration = async () => {
  load()
  await $http
    .get("/about")
    .then((res) => {
      items.value = res.partners
      console.log("API 取得", items.value)
    })
    .catch((err) => {
      console.error(err)
    })
  unload()
}
onBeforeMount(() => getCollaboration())

// 編輯、新增、刪除合作夥伴資料
const editCollaboration = async () => {
  load()
  await $http
    .put("/about", {
      params: {
        type: "partners",
      },
      data: items.value,
    })
    .then(() => {
      handleExpand("", -1)
      handleMessage()
      console.log("PUT 給 API", items.value)
    })
    .finally(() => {
      getCollaboration()
    })
  unload()
}
const handleMessage = () => {
  switch (emitAction.value) {
    case "delete":
      messageStore.set({ msg: "已刪除", ctaText: "復原" })
      break
    case "edit":
      messageStore.set({ msg: "已儲存", ctaText: "確定" })
      break
    default:
      messageStore.clear()
      break
  }
}

watch(
  () => editingItem.value.key,
  () => {
    collaboration.value = editingItem.value.text || ""
    collaborationImage.value = editingItem.value.image || ""
  },
  { immediate: true }
)
</script>
<style scoped></style>
